/* eslint-disable no-case-declarations */
import axios, { AxiosResponse } from 'axios';
// eslint-disable-next-line
import { ValidateCoordinate } from './validation';
import config, {
    LOCATION_TYPE_CHARGING_STATION,
    LOCATION_TYPE_EV_CHARGING_STATION,
    LOCATION_TYPE_KIOSK,
    LOCATION_TYPE_PARKING,
} from './config';
import firebase from 'firebase/app';
import Location from './locations';
import { IAddDeviceToken, IPushData } from '../interfaces';
import * as L from 'mapbox-gl';

// axios.interceptors.request.use(
//     function(successfulReq) {
//         console.log("[interceptors.request] successfulReq")
//         return successfulReq;
//     },
//     function(error) {
//         console.log("[interceptors.request] Promise.reject(error)")
//         config.__retryCount = config.__retryCount || 0
//         if (config.__retryCount >= 1) {
//             return Promise.reject(error);
//         }
//         config.__retryCount += 1
//         const backoff = new Promise(function (resolve){
//             setTimeout(function () {
//                 resolve()
//             }, 1)
//         })
//
//         return backoff.then(function (){
//             return axios(config)
//         })
//     }
// );

axios.interceptors.response.use(
    function axiosSuccessInterceptor(resp) {
        // console.log("[interceptors.response] axiosSuccessInterceptor(resp)", resp)
        if (resp?.status === 200) {
            if (resp.data?.code === 408) {
                if (
                    resp.data.msg?.code === 'auth/argument-error' ||
                    resp.data.msg?.code === 'auth/id-token-expired' ||
                    resp.data.msg?.code.startsWith('auth/')
                ) {
                    if (firebase.auth().currentUser) {
                        firebase
                            .auth()
                            .currentUser?.getIdToken(true)
                            .then(function (newToken) {
                                // TODO: Retry request?
                                // if (resp.config?.data) {
                                //     let data = JSON.parse(resp.config.data)
                                //     if (data.firebase_token) {
                                //         data.firebase_token = newToken
                                //         let dataStr = JSON.stringify(data)
                                //         resp.config.data = dataStr
                                //     }
                                // }
                            })
                            .catch(function () {
                                console.error('Failed to refresh auth token');
                            });
                    }
                }
            }
        }
        return resp;
    },
    async function axiosRetryInterceptor(err) {
        // console.log("[interceptors.response] axiosRetryInterceptor(err)", err)
        if (err.status === 401) {
            if (firebase.auth().currentUser) {
                firebase
                    .auth()
                    .currentUser?.getIdToken(true)
                    .catch(function () {
                        console.error('Failed to refresh auth token');
                    });
            }
        }
        return await Promise.reject(err);
    },
);

function createLocationsList(itemsList: any, type: any) {
    let locationsList = [];
    for (let i = 0; i < itemsList.length; i++) {
        let item = itemsList[i];
        switch (type.toLowerCase()) {
            case LOCATION_TYPE_KIOSK:
                let kioskLocation = new Location(
                    item,
                    LOCATION_TYPE_KIOSK,
                    item.latitude,
                    item.longitude,
                );
                locationsList.push(kioskLocation);
                break;
            case LOCATION_TYPE_CHARGING_STATION:
                let chargingStation = new Location(
                    item,
                    LOCATION_TYPE_CHARGING_STATION,
                    item.coordinates.lat,
                    item.coordinates.lng,
                );
                locationsList.push(chargingStation);
                break;
            case LOCATION_TYPE_EV_CHARGING_STATION:
                item.id = item.ID;
                let evChargingStation = new Location(
                    item,
                    LOCATION_TYPE_EV_CHARGING_STATION,
                    item.AddressInfo.Latitude,
                    item.AddressInfo.Longitude,
                );
                locationsList.push(evChargingStation);
                break;
            case LOCATION_TYPE_PARKING:
                let parking = new Location(
                    item,
                    LOCATION_TYPE_PARKING,
                    item.coordinates.lat,
                    item.coordinates.lng,
                );
                locationsList.push(parking);
                break;
            default:
                break;
        }
    }

    return locationsList;
}

export async function loadLocationsByCoordinates(bounds: L.LngLatBounds) {
    let locationsList: any[] = [];
    // try {
    //     let kioskListResp = await getKioskListByCoordinates(bounds)
    //     if (kioskListResp.data.code === 1) {
    //         locationsList = locationsList.concat(createLocationsList(kioskListResp.data.merchants, LOCATION_TYPE_KIOSK))
    //     }
    // } catch (err) {
    //     console.log(err)
    // }

    // try {
    //     let chargingStationsResp = await contractorsLocationsInspect('station', bounds)
    //     // if (chargingStationsResp.status === 200) {
    //     if (chargingStationsResp.data?.locations) {
    //         locationsList = locationsList.concat(createLocationsList(chargingStationsResp.data.locations, LOCATION_TYPE_CHARGING_STATION))
    //     }
    // } catch (err) {
    //     console.log(err)
    // }

    try {
        let evChargingStationsResp: any = await getEVChargingStations(bounds);
        console.log(evChargingStationsResp);
        if (evChargingStationsResp.data) {
            locationsList = locationsList.concat(
                createLocationsList(
                    evChargingStationsResp.data,
                    LOCATION_TYPE_EV_CHARGING_STATION,
                ),
            );
        }
    } catch (err) {
        console.log(err);
    }

    // try {
    //     let parkingResp = await getParking(bounds)
    //     if (parkingResp.data?.locations) {
    //         locationsList = locationsList.concat(createLocationsList(parkingResp.data.locations, LOCATION_TYPE_PARKING))
    //     }
    // } catch (err) {
    //     console.log(err)
    // }

    // let chargingStations = await contractorsLocationsInspect('station', bounds)

    return locationsList;
}

/**
 * @param bounds Must be a MapBox Bounds object.
 */
export async function getKioskListByCoordinates(bounds: L.LngLatBounds) {
    config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/getseller/index`,
              data: {
                  oid: 1,
                  firebase_token: await getToken(),
                  longitude: bounds?.getCenter().lng,
                  latitude: bounds?.getCenter().lat,
              },
          })
        : new Error('fdvef');
}

/**
 * @param locationType Must be "station".
 * @param bounds Must be a MapBox Bounds object.
 */
export async function contractorsLocationsInspect(
    locationType: string,
    bounds: string,
) {
    return JSON.parse(
        '{"data":{"locations":[{"id":"d139d3f4-7900-4a61-bdee-a09cd2b16051","type":"station","coordinates":{"lat":26.947,"lng":-80.129},"address":"38 Shores Pointe Drive, Jupiter FL","stallsTotal":12,"stallsAvailable":11,"availableStallsList":[0,1,2,3,4,5,7,8,9,10,11]},{"id":"c9570af3-8935-48f1-85c6-aab17a7f0c1d","type":"station","coordinates":{"lat":26.937,"lng":-80.119},"address":"54 Shores Pointe Drive, Jupiter FL","stallsTotal":12,"stallsAvailable":10,"availableStallsList":[0,2,3,4,5,7,8,9,10,11]},{"id":"2a8d60d1-b5f6-499c-8457-b0d448f50871","type":"station","coordinates":{"lat":26.938,"lng":-80.121},"address":"131 Shores Pointe Drive, Jupiter FL","stallsTotal":12,"stallsAvailable":10,"availableStallsList":[0,1,2,3,4,5,8,9,10,11]},{"id":"94c635c5-dae0-4e39-b2de-92d220ff4a66","type":"station","coordinates":{"lat":26.937,"lng":-80.139},"address":"65 Shores Pointe Drive, Jupiter FL","stallsTotal":12,"stallsAvailable":12,"availableStallsList":[0,1,2,3,4,5,6,7,8,9,10,11]},{"id":"002c9e88-ea72-404a-b3ce-5462f340dad9","type":"container","coordinates":{"lat":26.938,"lng":-80.140},"address":"2330 Kuhio Av, Honolulu, HI 96815-2951","countryCode":"US","timeZone":"Pacific/Honolulu","currency":{"code":"USD","decimals":2},"slotting":{"id":"873c5cc0-7539-4cd4-b7f7-5f0eb3e556dc","type":"fixedSlotDay","fixedSlotDayStart":"09:00:00","fixedSlotDayDurationSeconds":82800,"fixedSlotDayMultipleSlotsDiscount":{"minimumNumberOfSlots":3,"discount":10}},"reservables":[{"id":"2916a086-1234-4925-92c5-f17e7aa52f09","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 01"},{"id":"3adbdcdd-7485-4ddc-8630-9015a6e00f9a","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 02"},{"id":"f4279f06-d6f5-4479-89a2-9d9372ebfb2b","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 03"},{"id":"79c7abd6-e0a7-47c3-a1e7-bf3c275a7a88","type":"containerBay","currentAvailability":"available","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 04"}],"HALAdapterType":"none","operatingMode":"","partnersList":null,"metadata":{"lastPing":"2021-04-23T12:20:39.88739869Z","stallsTotal":4,"stallsInUse":2}}]}}',
    );
    // return axios({
    //     method: 'post',
    //     url:  `http://localhost:3001/contractors/locationsInspect`,
    //     headers: {
    //         Authorization: `Bearer ${await getToken()}`
    //     },
    //     data: {
    //         type: locationType,
    //         southWest: {
    //             lat: ValidateCoordinate('lat', bounds.getSouthWest().lat),
    //             lng: ValidateCoordinate('lng', bounds.getSouthWest().lng)
    //         },
    //         northEast: {
    //             lat: ValidateCoordinate('lat', bounds.getNorthEast().lat),
    //             lng: ValidateCoordinate('lng', bounds.getNorthEast().lng)
    //         }
    //     }
    // })
}

/**
 * @param locationId Location id.
 */
export async function getParkingById(locationId: string) {
    return JSON.parse(
        '{"data":{"location":{"id":"002c9e88-ea72-404a-b3ce-5462f340dad9","type":"container","coordinates":{"lat":26.938,"lng":-80.140},"address":"2330 Kuhio Av, Honolulu, HI 96815-2951","countryCode":"US","timeZone":"Pacific/Honolulu","currency":{"code":"USD","decimals":2},"slotting":{"id":"873c5cc0-7539-4cd4-b7f7-5f0eb3e556dc","type":"fixedSlotDay","fixedSlotDayStart":"09:00:00","fixedSlotDayDurationSeconds":82800,"fixedSlotDayMultipleSlotsDiscount":{"minimumNumberOfSlots":3,"discount":10}},"reservables":[{"id":"2916a086-1234-4925-92c5-f17e7aa52f09","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 01"},{"id":"3adbdcdd-7485-4ddc-8630-9015a6e00f9a","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 02"},{"id":"f4279f06-d6f5-4479-89a2-9d9372ebfb2b","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 03"},{"id":"79c7abd6-e0a7-47c3-a1e7-bf3c275a7a88","type":"containerBay","currentAvailability":"available","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 04"}],"HALAdapterType":"none","operatingMode":"","partnersList":null,"metadata":{"lastPing":"2021-04-23T12:20:39.88739869Z","stallsTotal":4,"stallsInUse":2}}}}',
    );
}

/**
 * @param locationId Location id.
 */
export async function getEvChargingStationById(locationId: string) {
    return JSON.parse(
        '{"data":{"location":{"id":"002c9e88-ea72-404a-b3ce-5462f340dad9","type":"container","coordinates":{"lat":26.938,"lng":-80.140},"address":"2330 Kuhio Av, Honolulu, HI 96815-2951","countryCode":"US","timeZone":"Pacific/Honolulu","currency":{"code":"USD","decimals":2},"slotting":{"id":"873c5cc0-7539-4cd4-b7f7-5f0eb3e556dc","type":"fixedSlotDay","fixedSlotDayStart":"09:00:00","fixedSlotDayDurationSeconds":82800,"fixedSlotDayMultipleSlotsDiscount":{"minimumNumberOfSlots":3,"discount":10}},"reservables":[{"id":"2916a086-1234-4925-92c5-f17e7aa52f09","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 01"},{"id":"3adbdcdd-7485-4ddc-8630-9015a6e00f9a","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 02"},{"id":"f4279f06-d6f5-4479-89a2-9d9372ebfb2b","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 03"},{"id":"79c7abd6-e0a7-47c3-a1e7-bf3c275a7a88","type":"containerBay","currentAvailability":"available","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 04"}],"HALAdapterType":"none","operatingMode":"","partnersList":null,"metadata":{"lastPing":"2021-04-23T12:20:39.88739869Z","stallsTotal":4,"stallsInUse":2}}}}',
    );
}

/**
 * @param locationId Location id.
 */
export async function getChargingStationById(locationId: string) {
    return JSON.parse(
        '{"data":{"location":{"id":"002c9e88-ea72-404a-b3ce-5462f340dad9","type":"container","coordinates":{"lat":26.938,"lng":-80.140},"address":"2330 Kuhio Av, Honolulu, HI 96815-2951","countryCode":"US","timeZone":"Pacific/Honolulu","currency":{"code":"USD","decimals":2},"slotting":{"id":"873c5cc0-7539-4cd4-b7f7-5f0eb3e556dc","type":"fixedSlotDay","fixedSlotDayStart":"09:00:00","fixedSlotDayDurationSeconds":82800,"fixedSlotDayMultipleSlotsDiscount":{"minimumNumberOfSlots":3,"discount":10}},"reservables":[{"id":"2916a086-1234-4925-92c5-f17e7aa52f09","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 01"},{"id":"3adbdcdd-7485-4ddc-8630-9015a6e00f9a","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 02"},{"id":"f4279f06-d6f5-4479-89a2-9d9372ebfb2b","type":"containerBay","currentAvailability":"unavailable","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 03"},{"id":"79c7abd6-e0a7-47c3-a1e7-bf3c275a7a88","type":"containerBay","currentAvailability":"available","unitPrice":1000,"containerBayCapacity":20,"containerBayLabel":"Bay 04"}],"HALAdapterType":"none","operatingMode":"","partnersList":null,"metadata":{"lastPing":"2021-04-23T12:20:39.88739869Z","stallsTotal":4,"stallsInUse":2}}}}',
    );
}

/**
 * @param bounds Must be a MapBox Bounds object.
 */
export async function getEVChargingStations(bounds: L.LngLatBounds) {
    let swLat = bounds.getSouthWest().lat;
    let swLng = bounds.getSouthWest().lng;
    let neLat = bounds.getNorthEast().lat;
    let neLng = bounds.getNorthEast().lng;
    return config.openChargeMapApiBaseUrl
        ? await axios({
              method: 'get',
              headers: {
                  'X-API-Key': config.openChargeMapApiKey,
              },
              url: `${config.openChargeMapApiBaseUrl}/v3/poi/?output=json&boundingbox=(${swLat},${swLng}),(${neLat},${neLng})`,
          })
        : new Error('point the baseurl');

    //return JSON.parse("{\"data\":{\"locations\":[{\"address\":\"1 Shores Pointe Drive, Jupiter FL\",\"availableLotsList\":[0,1,2],\"availableLots\":3,\"totalLots\":4,\"coordinates\":{\"lat\":26.937,\"lng\":-80.125},\"id\":\"94c635c5-dae0-4e39-b2de-92d220ff4a66\"},{\"address\":\"14 Shores Pointe Drive, Jupiter FL\",\"availableLotsList\":[1,2],\"availableLots\":2,\"totalLots\":4,\"coordinates\":{\"lat\":26.933,\"lng\":-80.125},\"id\":\"3231-dae0-4e39-b2de-92d220ff4a66\"}]}}")
}

/**
 * @param bounds Must be a MapBox Bounds object.
 */
// export async function getParking(bounds) {
//     return JSON.parse(
//         '{"data":{"locations":[{"address":"5 Shores Pointe Drive, Jupiter FL","available":7,"total":20,"coordinates":{"lat":26.936,"lng":-80.128},"id":"p125c5-dae0-4e39"},{"address":"13 Shores Pointe Drive, Jupiter FL","available":2,"total":4,"coordinates":{"lat":26.948,"lng":-80.125},"id":"p24c635c5-dae0-4e39"}]}}',
//     );
// }

/**
 * @param locationType Must be "station".
 * @param locationID Must be a location ID.
 */
export async function contractorsLocationGet(
    locationType: string,
    locationID: string,
) {
    return await axios({
        method: 'post',
        url: `http://localhost:3001/contractors/location`,
        headers: {
            Authorization: `Bearer ${(await getToken()) ?? ''}`,
        },
        data: {
            type: locationType,
            locationId: locationID,
        },
    });
}

async function getToken() {
    return await firebase.auth().currentUser?.getIdToken();
}

export async function GetFirebaseToken() {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/debug/getIdToken`,
              data: {
                  uid: config.user.uid,
              },
          })
        : new Error('point the baseurl');
}

export async function GetUserInfo() {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/user/getinfo`,
              data: {
                  firebase_token: await getToken(),
              },
          })
        : new Error('point the baseurl');
}

export async function CheckUser(phoneNumber: string) {
    config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/user/checkUser`,
              data: {
                  mobile: phoneNumber,
              },
          })
        : new Error('point the baseurl');
}

export async function UpdateUserProfile(userId: string, nickName: string) {
    // return mock response
    return { data: { code: 1 } };
    // return axios({
    //     method: 'post',
    //     url:  `${config.powerBanksApiBaseUrl}/user/updateUser`,
    //     data: {
    //         id: userId,
    //         name: nickName
    //     }
    // })
}

export async function ConfirmRent(boxId: string) {
    let userInfo = config.getUserInfo();
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/leaseorder/to_lease`,
              data: {
                  cabinetid: boxId,
                  firebase_token: await getToken(),
                  oid: 1,
                  stripe_cus_id: userInfo.stripe_cus_id,
                  cid: 11,
              },
          })
        : new Error('point the baseurl');
}

export async function GetCabinetStatus(boxId: string) {
    config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/getseller/cabinetstatus`,
              data: {
                  cabinetid: boxId,
                  firebase_token: await getToken(),
              },
          })
        : new Error('point the baseurl');
}

export async function GetCabinetAvailabilityInfo(kioskId: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/cabinet/checkStatus`,
              data: {
                  cabinetid: kioskId,
              },
          })
        : new Error('point the baseurl');
}

export async function GetPriceInfo(kioskId: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/leaseorder/getprice`,
              data: {
                  oid: 1,
                  cid: kioskId,
                  firebase_token: await getToken(),
              },
          })
        : new Error('point the baseurl');
}

export async function GetLeaseOrderList(oid: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/leaseorder/leaseorderlist`,
              data: {
                  oid,
                  firebase_token: await getToken(),
              },
          })
        : new Error('point the baseurl');
}

export async function GetLeaseOrderInfo(orderId: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/leaseorder/leaseorderinfo`,
              data: {
                  oid: 1,
                  firebase_token: await getToken(),
                  orderid: orderId,
              },
          })
        : new Error('point the baseurl');
}

export async function GetMessagesList() {
    let userInfo = config.getUserInfo();
    config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/inbox/getMessages`,
              data: {
                  uid: userInfo.id,
              },
          })
        : new Error('point the baseurl');
}

export async function GetMerchantByReferralCode(referralCode: string) {
    // Return mock data
    // 2FowoFUbLkqQTrvgR4G8dQ - Home Depot
    // uThrlAsIkkOsdnGTPoTZZQ - Citi Field
    //
    // let result = null
    // switch (referralCode) {
    //     case "2FowoFUbLkqQTrvgR4G8dQ": {
    //         result = {"data":{"code": 1, "merchantId": 8, "merchantName": "Home Depot"}};
    //         break;
    //     }
    //     case "uThrlAsIkkOsdnGTPoTZZQ": {
    //         result = {"data":{"code": 1, "merchantId": 12, "merchantName": "Citi Field"}};
    //         break;
    //     }
    //     case "CFu91rlAONEkOnsnGTPoPZ": {
    //         result = {"data":{"code": 1, "merchantId": 3, "merchantName": "Walmart"}};
    //         break;
    //     }
    //     default: {
    //         result = {"data":{"code": 404}}
    //     }
    // }
    // return result

    return await axios({
        method: 'post',
        url: `https://api.install.co/Merchant/checkReferralCode`,
        data: {
            referralCode,
        },
    });
}

export async function GetMerchantInfo(merchantId: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/getseller/info`,
              data: {
                  oid: 1,
                  id: merchantId,
                  firebase_token: await getToken(),
              },
          })
        : new Error('point the baseurl');
}

export async function UpdateAssignedMerchant(
    userId: string,
    merchantId: string,
) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/user/updateAssignedMerchant`,
              data: {
                  users: [
                      {
                          assigned_merchant: merchantId,
                          user_id: userId,
                      },
                  ],
              },
          })
        : new Error('point the baseurl');
}

export async function CheckReferralCode(referralCode: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/user/checkReferral`,
              data: {
                  users: [
                      {
                          referralCode,
                      },
                  ],
              },
          })
        : new Error('point the baseurl');
}

export async function RegisterCard(cardToken: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/user/registerCard`,
              data: {
                  firebase_token: await getToken(),
                  card_token: cardToken,
              },
          })
        : new Error('point the baseurl');
}

export async function DeleteCard(cardToken: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/user/deleteCard`,
              data: {
                  firebase_token: await getToken(),
                  card: cardToken,
              },
          })
        : new Error('point the baseurl');
}

export async function UpdatePrimaryCard(cardToken: string) {
    return config.powerBanksApiBaseUrl
        ? await axios({
              method: 'post',
              url: `${config.powerBanksApiBaseUrl}/user/updatePrimaryCard`,
              data: {
                  firebase_token: await getToken(),
                  card: cardToken,
              },
          })
        : new Error('point the baseurl');
}

export async function AddDeviceToken(userInfo: IAddDeviceToken) {
    return await axios({
        method: 'post',
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        url: 'https://demo-notify.install.co/tok',
        data: { ...userInfo, firebase_token: await getToken() },
    });
}

export async function GetTokens() {
    return await axios({
        method: 'get',
        url: 'https://demo-notify.install.co/get-tokens',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
        },
    });
}

export async function PushNotification(pushData: IPushData) {
    return await axios({
        headers: {
            Authorization:
                'key=AAAA1a17yWs:APA91bFysmkNv3dZcwhh2yUS0YqBsXtjd8wSCE25rXTv092-_6by5rsOvNg4ze_7xqYOPr5fz2kuYnJD6o1NbDZ-WbWIM1xnOJou8Sefx94538wSTxsYimVlqoyDO5BvEXtfm_GIanrT',
        },
        method: 'post',

        url: 'https://fcm.googleapis.com/fcm/send',
        data: { ...pushData },
    });
}
